import { REDUX_ACTIONS } from '../../shared/config/constants';
const initialState = {
  loading: false,
  deleting: false,
  data: [],
  inputs: [],
  units: {},
  errorMessage: '',
  loadingDelete: false,
  saved: false,
  paginatedElements: 0,
  parametricAnalysisChartData: {
    inputs: [],
    results: [],
    units: {},
    run_details_copy: {},
    paginatedElements: 0
  }
};
const hydraulicsParameterAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        inputs: [...action.payload.inputs],
        data: [...action.payload.data],
        units: { ...action.payload.units },
        paginatedElements: action.payload.paginatedElements,
        permissionId: action?.payload?.permissionId ?? null,
        permissions: action?.payload?.permissions ?? state?.permissions ?? {},
        createdDetails: action?.payload?.lastUpdate
          ? {
              createdBy: action?.payload?.createdBy,
              lastUpdate: action?.payload?.lastUpdate,
              lastUpdatedBy: action?.payload?.lastUpdatedBy
            }
          : state?.createdDetails,
        errorMessage: ''
      };
    case REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_LIST_ERROR_NOTIFIED:
      return {
        ...state,
        errorMessage: '',
        data: []
      };
    case REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_RESET:
      return {
        ...initialState
      };
    case REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_LOADING:
      return {
        ...state,
        parametricAnalysisChartData: {
          ...state.parametricAnalysisChartData,
          loading: true,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_SUCCESS:
      return {
        ...state,
        parametricAnalysisChartData: {
          ...state.parametricAnalysisChartData,
          loading: false,
          inputs: [...action.payload.inputs],
          results: [...action.payload.results],
          units: { ...action.payload.units },
          run_details_copy: { ...action.payload.run_details_copy },
          paginatedElements: action.payload.paginatedElements,
          errorMessage: ''
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_DATA_LIST_ERROR:
      return {
        ...state,
        parametricAnalysisChartData: {
          ...state.parametricAnalysisChartData,
          loading: false,
          errorMessage: action.payload.message,
          data: []
        }
      };
    case REDUX_ACTIONS.HYDRAULICS_PARAMETER_ANALYSIS_SET_FALSE:
      return {
        ...state,
        loading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
};
export default hydraulicsParameterAnalysisReducer;
